import {Button, Card, CardContent, Typography} from '@mui/material';

export interface ModuleSettingsEmptyCardProps {
  onAddModule: () => void;
}

export default function ModuleSettingsEmptyCard({onAddModule}: ModuleSettingsEmptyCardProps) {
  return (
    <Card data-testid="module-settings-empty-card">
      <CardContent sx={{textAlign: 'center', py: 4}}>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          No modules selected
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{mb: 3}}>
          You haven&apos;t selected any study modules yet. Add a module to get started with your studies.
        </Typography>
        <Button
          variant="contained"
          onClick={onAddModule}
          sx={{bgcolor: '#1B263B', '&:hover': {bgcolor: '#1B263B', opacity: 0.8}}}
          data-testid="add-module-button"
        >
          Add Module
        </Button>
      </CardContent>
    </Card>
  );
}
